query GetPledge($id: ID!) {
  pledge(id: $id) {
    id
    firstName
    surname
    userId
    createdDate
    pledgorHomeCountry
    companyName
    currentPercentage
    dateSigned
    countersigned
    valuation
    shareholdingPercentage
    countersignatureUrl
    signed
    closer {
      id
      name
    }
  }
}
